import React from 'react';
import { Chip, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  standardBadge: {
    fontSize: '0.75rem',
    fontWeight: 'bold',
    borderRadius: 16,
    height: 24,
    '& .MuiChip-label': {
      paddingLeft: 8,
      paddingRight: 8,
    },
    '& .MuiChip-icon': {
      fontSize: '0.875rem',
      marginLeft: 6,
      marginRight: -2,
    },
  },

  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&.outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
    },
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '&.outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main,
    },
  },
  success: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
    '&.outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.success.main,
      borderColor: theme.palette.success.main,
    },
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
    '&.outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.warning.main,
      borderColor: theme.palette.warning.main,
    },
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&.outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.error.main,
      borderColor: theme.palette.error.main,
    },
  },
  info: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.info.contrastText,
    '&.outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.info.main,
      borderColor: theme.palette.info.main,
    },
  },
  default: {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.text.primary,
    '&.outlined': {
      backgroundColor: 'transparent',
      color: theme.palette.text.primary,
      borderColor: theme.palette.grey[300],
    },
  },
}));

/**
 * Componente Badge padronizado
 * Baseado no design do TicketTimer para consistência visual
 */
const StandardBadge = ({
  label,
  color = 'default',
  variant = 'filled',
  icon,
  size = 'small',
  className = '',
  onClick,
  ...props
}) => {
  const classes = useStyles();

  const badgeClasses = [
    classes.standardBadge,
    classes[color],
    variant === 'outlined' ? 'outlined' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <Chip
      label={label}
      size={size}
      icon={icon}
      variant={variant === 'outlined' ? 'outlined' : 'default'}
      className={badgeClasses}
      clickable={!!onClick}
      onClick={onClick}
      {...props}
    />
  );
};

export default StandardBadge;